export const PAGINATION_DEFAULTS = {
  pageSize: 20,
  current: 1,
  hideOnSinglePage: true,
  showTitle: false,
};

export const USERS_WIZARD_SEARCH = "councils/users/search";
